import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const _admin_login_api = async (data) => {
  const requestObj = {
    path: `api/admin/login`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};
///////////////// dashboard api ////////////////////////////
export const _get_dashboard_data = async (start_Date, end_Date) => {
  const requestObj = {
    path: `api/admin/get_admin_dashboard?start_date=${start_Date}&end_date=${end_Date}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },

    // postData: data,
  };
  return invokeApi(requestObj);
};
///////////cases///////////////////
export const get_cases_api = async (
  caseParam,
  state,
  search,
  statusparam,
  startDateParam,
  endDateParam,
  id,
  page,
  limit
) => {
  const requestObj = {
    path: `api/cases/list_cases?case_type=${caseParam}&state=${state}&search=${search}&status=${statusparam}&start_date=${startDateParam}&end_date=${endDateParam}&advisor_id=${id}&page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_cases_Detail_api = async (
  caseParam,
  state,
  search,
  statusparam,
  startDateParam,
  endDateParam,
  page,
  limit,
  advisor_id
) => {
  const requestObj = {
    path: `api/cases/list_cases_for_advisor?case_type=${caseParam}&state=${state}&search=${search}&status=${statusparam}&start_date=${startDateParam}&end_date=${endDateParam}&page=${page}&limit=${limit}&advisor_id=${advisor_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const update_case_Status = async (data, id) => {
  const requestObj = {
    path: `api/cases/update_case/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },

    postData: data,
  };
  return invokeApi(requestObj);
};
export const _detail_customer_for_admin_api = async (id) => {
  const requestObj = {
    path: `api/cases/get_case_detail/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const delete_Case_api = async (id) => {
  const requestObj = {
    path: `api/cases/delete_case/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    // postData: data,
  };
  return invokeApi(requestObj);
};
export const change_case_api = async (ID, new_status) => {
  const requestObj = {
    path: `api/cases/toggle_case/${ID}?new_status=${new_status}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const change_Advisor_api = async (ID, advId) => {
  const requestObj = {
    path: `api/cases/change_advisor/${ID}/${advId}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
//<=======================advisor api==========================>//
export const get_advisor_list_api = async (state, category) => {
  const requestObj = {
    path: `api/advisor/list_advisor_against_pool?name=&category=${category}&state=${state}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_Advisor_list_for_Caeses = async (state, category) => {
  const requestObj = {
    path: `api/advisor/list?name=&category=${category}&state=${state}&page=${1}&limit=${100}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_advisor_list_with_filters = async (
  caseParam,
  state,
  ratio_param,
  sorted,
  search,
  page,
  limit
) => {
  console.log(search, "searchsearchsearch");
  const requestObj = {
    path: `api/advisor/list?name=${search}&category=${caseParam}&state=${state}&sort_by=${ratio_param}&sort_order=${sorted}&page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const delete_attorney_Api = async (id) => {
  const requestObj = {
    path: `api/advisor//${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const add_Advisor_api = async (data) => {
  const requestObj = {
    path: `api/advisor`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },

    postData: data,
  };
  return invokeApi(requestObj);
};
export const update_Advisor_api = async (data, ID) => {
  const requestObj = {
    path: `api/advisor/update/${ID}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const detail_advisor_api_for_Admin = async (id) => {
  const requestObj = {
    path: `api/advisor/detail/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const admin_change_password = async (data) => {
  const requestObj = {
    path: `api/admin/change_password`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
///<=====================settings section======================>
export const get_default_settings_for_admin = async () => {
  const requestObj = {
    path: `api/admin_portal_settings/get_admin_portal_settings`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    // postData: data,
  };
  return invokeApi(requestObj);
};
export const add_default_settings_for_admin = async (data) => {
  const requestObj = {
    path: `api/admin_portal_settings/add_admin_portal_settings`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },

    postData: data,
  };
  return invokeApi(requestObj);
};
// admin edit-profile-api ==================>
export const edit_profile_admin_api = async (data) => {
  const requestObj = {
    path: `api/admin/edit_admin`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const email_verification_api = async (data) => {
  const requestObj = {
    path: `api/admin/email_verification`,
    method: "POST",
    headers: {
      // "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const otp_verification_api = async (data) => {
  const requestObj = {
    path: `api/admin/code_verification`,
    method: "POST",
    headers: {
      // "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const confirm_password_Api = async (data) => {
  const requestObj = {
    path: `api/admin/reset_password`,
    method: "POST",
    headers: {
      // "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
// ==============================pools===============================//
export const pool_list_api = async (search, state, type, page, limit) => {
  console.log(search, "searchsearchsearch");
  const requestObj = {
    path: `api/advisor/list_pool?name=${search}&state=${state}&case_type=${type}&page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_pool_attorney_list = async (id, search, page, limit) => {
  console.log(search, "searchsearchsearch");
  const requestObj = {
    path: `api/advisor/list_attorney_for_pool?pool_id=${id}&name=${search}&page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const change_attorney_percentage_api = async (data) => {
  const requestObj = {
    path: `api/advisor/change_percentage`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
